// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "packs/css/" + "modals/event-map-modal" + "-" + "cc9b924a" + ".chunk.css";
};